export default __webpack_public_path__ + "media/images/logo_light-459b34425fa0a8b53715aac9aa2115fb.png";